module.exports = __webpack_public_path__ + "img/8.b424ef09.png";